import { render, staticRenderFns } from "./FormFlotador.vue?vue&type=template&id=6353468f&scoped=true&"
import script from "./FormFlotador.vue?vue&type=script&lang=js&"
export * from "./FormFlotador.vue?vue&type=script&lang=js&"
import style0 from "./FormFlotador.vue?vue&type=style&index=0&id=6353468f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6353468f",
  null
  
)

export default component.exports